/**
 * React Query hook for fetching all matches
 */

import { matchesService } from "@features/messaging/services/matchesService";
import { sortMatchesByLastMessageTime } from "@features/messaging/utils/matchUtils";
import logger from "@logger";
import { matchesQueryKeys } from "@shared/queryKeys";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch all matches (for chat list), sorted by last message time (most recent first).
 */
export function useAllMatches(userId: string) {
  return useQuery({
    queryKey: matchesQueryKeys.allMatches(userId),
    queryFn: async () => {
      try {
        logger.info("Fetching all matches", { userId });
        return await matchesService.getAllMatches(userId);
      } catch (error) {
        logger.error("Error fetching all matches:", error);
        throw error;
      }
    },
    select: sortMatchesByLastMessageTime,
    enabled: !!userId,
    staleTime: 1 * 60 * 1000, // 1 minute (shorter for chat list)
    gcTime: 5 * 60 * 1000, // 5 minutes
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}
